var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaystoreIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13559_103308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5689 26.114C32.3075 23.5121 35.8998 21.5295 36.2094 21.3753C37.2 20.8486 38.2229 19.4544 36.2094 18.3715C35.5594 18.0309 32.0594 16.11 27.5689 13.6328L21.3438 19.9197L27.5689 26.1138V26.114Z",
    fill: "#FFD900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3449 19.918L1.52344 39.895C1.98869 39.9567 2.51395 39.8333 3.13322 39.4929C4.43336 38.7812 18.2161 31.2543 27.57 26.1137L21.3449 19.918Z",
    fill: "#F43249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3445 19.9188L27.5696 13.6629C27.5696 13.6629 4.52693 1.08757 3.13277 0.345236C2.60752 0.0341415 2.0189 -0.0582673 1.49219 0.0341415L21.3445 19.9188Z",
    fill: "#00EE76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3447 19.9198L1.49243 0.0351562C0.686735 0.221434 0.00585938 0.933258 0.00585938 2.38902V37.543C0.00585938 38.8754 0.532721 39.8352 1.52323 39.9277L21.3447 19.9198Z",
    fill: "#00D3FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13559_103308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.3833,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystoreIcon);
export default __webpack_public_path__ + "static/media/playstoreIcon.9ed10d038ea74cc1d6eb8dc52f64a50b.svg";
export { ForwardRef as ReactComponent };